import { DatePicker, Select } from "antd";
import moment from "moment";
import locale from "antd/es/date-picker/locale/zh_TW";
import React, { useContext, useState } from "react";
import {
  PickerBaseProps,
  PickerDateProps,
  PickerTimeProps,
} from "antd/lib/date-picker/generatePicker";
import { staticText } from "../../utils/staticText";
import { useLocation } from "react-router-dom";
import { InitContext } from "../../contexts/init";
import { OverviewContext } from "../../contexts/overview";
import dpIfIdToView from "../../utils/dpIfIdToView";
import { locationState } from "../../utils/types";

const { Option } = Select;

export const Control = () => {
  const { data: InitData, dispatch: InitDispatch } = useContext(InitContext);
  const { dptTyp: dptTypList, datepickerOpen } = InitData;
  const { data, dispatch } = useContext(OverviewContext);
  const { tmp, tmpList, workDate, pubDates } = data;
  const { state } = useLocation<locationState>();
  const { overview } = staticText;

  const [testInput, setTestInput] = useState<React.Component<
    | PickerBaseProps<moment.Moment>
    | PickerDateProps<moment.Moment>
    | PickerTimeProps<moment.Moment>,
    any,
    any
  > | null>();

  const handleDateChange = (date: moment.Moment | null) => {
    if (date) {
      dispatch({
        type: "setState",
        payload: {
          workDate: moment(date).startOf("day"),
          tmpWok: 0,
        },
      });

      // @ts-ignore
      if (testInput) testInput.blur(); // ? TYPE?
    }
  };

  return (
    <div className="control-box overview">
      <div className="select-group">
        <h5>{overview.control.text1}</h5>
        <DatePicker
          inputReadOnly
          defaultPickerValue={moment()}
          value={workDate}
          locale={locale}
          open={datepickerOpen}
          onOpenChange={(value) =>
            InitDispatch({
              type: "setState",
              payload: { datepickerOpen: value },
            })
          }
          onChange={handleDateChange}
          getPopupContainer={() =>
            document.querySelector(".date-picker-wrapper")
          }
          ref={(input) => setTestInput(input)}
          className="control-datePicker"
          placeholder={overview.control.placeholder.date}
          dateRender={(current) => {
            return (
              <div
                className={`ant-picker-cell-inner ${
                  pubDates.includes(current.format("YYYY-MM-DD")) ? "unpub" : ""
                }`}
              >
                {current.date()}
              </div>
            );
          }}
        />
      </div>
      <div className="select-group">
        <h5>{overview.control.text2}</h5>
        <Select
          onFocus={(e) => {
            e.target.setAttribute("readOnly", "true");
          }}
          allowClear
          placeholder={overview.control.placeholder.tmp}
          disabled={
            dptTypList
              .find((ele) =>
                ele.dpt.find((ele) => ele.id === parseInt(state?.dptId))
              )
              ?.dpt.find((ele) => ele.id === parseInt(state?.dptId))?.dsply ===
            "NoGpTk"
          }
          value={tmp ? tmp : null}
          onChange={(e) => {
            dispatch({
              type: "setState",
              payload: {
                tmp: e,
                tmpWok: 0,
                tmpWokList: [],
                wokList: [],
                work: { id: 0, name: "" },
                openCount: false,
                status: "showControl",
              },
            });
          }}
          className="control-tmp"
        >
          {tmpList.map((ele) => {
            return (
              <Option value={ele.id} key={ele.id}>
                {ele.name}
              </Option>
            );
          })}
        </Select>
      </div>
    </div>
  );
};
